module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-33.949edbd2.png";